import React from "react";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik } from "formik";

import {
  Stack,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  Instagram,
  Facebook,
  YouTube,
  Email,
  Phone,
} from "@mui/icons-material";

import { Row } from "./Row";
import { Col } from "./Col";
import { Button } from "./Button";
import { Input } from "./Inputs";

import logo from "../assets/Logo_Footer.png";
import logoSmart from "../assets/logo-smart.svg";

import { useApi } from "../hooks/useApi";
import { API_URL } from "../config/apiUrl";


export const Footer = () => {
  const [{ loading }, fetch] = useApi({ ...API_URL.CONTATO }, { manual: true });
  const navigate = useNavigate();

  const onNavigate = (item) => {
    const { url, outside } = item;
    if (outside) {
      window.open(url);
      return;
    }
    window.scrollTo(0, 0);
    navigate(url);
  };

  const onSubmit = (data) => {
    fetch({ data });
    window.location.reload();
  };

  const menus = [
    { nome: "Ache seu pintor", url: "/" },
    { nome: "Termos de uso Contratante", url: "/termo-contratante" },
    { nome: "Política de Privacidade", url: "/politica-privacidade" },
    {
      nome: "Clube Pro Pintor",
      url: "https://clubepropintor.com.br/",
      outside: true,
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        backgroundColor: "secondary.main",
        marginTop: 4,
      }}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Conteúdo principal: mesma largura do layout (lg) e padding igual dos lados */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 1600,
          margin: "0 auto",
          paddingLeft: "24px",
          paddingRight: "24px",
          py: 6,
          boxSizing: "border-box",
        }}
      >
        <Row
          container
          spacing={0}
          sx={{
            width: "100%",
            margin: 0,
            flexWrap: { xs: "wrap", md: "nowrap" },
            alignItems: { xs: "center", md: "flex-start" },
            justifyContent: { xs: "center", md: "flex-start" },
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          <Col xs={12} md={4} sx={{ mb: { xs: 4, md: 0 }, display: "flex", justifyContent: { xs: "center", md: "flex-start" }, alignItems: { xs: "center", md: "flex-start" } }}>
            <Stack alignItems={{ xs: "center", md: "flex-start" }} spacing={2}>
              <Box
                component="img"
                src={logo}
                alt="logo"
                sx={{ width: 220, height: 220, display: "block" }}
              />
              <Typography color="#fff" fontSize={12} fontWeight={600}>
                Administrado e Desenvolvido por
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Box component="img" src={logoSmart} alt="smart" sx={{ width: 100, height: "auto" }} />
                <Typography color="#fff" fontSize={14}>
                  Clube fidelidade
                </Typography>
              </Stack>
              <Stack direction="row" spacing={2}>
                <Box
                  sx={{
                    p: 1.5,
                    background: "#fff",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => onNavigate({ url: "https://www.facebook.com/swpropintor/", outside: true })}
                >
                  <Facebook color="secondary" />
                </Box>
                <Box
                  sx={{
                    p: 1.5,
                    background: "#fff",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() => onNavigate({ url: "https://www.instagram.com/swpropintor/", outside: true })}
                >
                  <Instagram color="secondary" />
                </Box>
                <Box
                  sx={{
                    p: 1.5,
                    background: "#fff",
                    borderRadius: "50%",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    onNavigate({
                      url: "https://www.youtube.com/watch?v=0Vu_Gh7G62Q&list=PL8HjbxoOFszjxkLxFPOAF-IVLh1zd7fbo",
                      outside: true,
                    })
                  }
                >
                  <YouTube color="secondary" />
                </Box>
              </Stack>
            </Stack>
          </Col>

          <Col xs={12} md={4} sx={{ mb: { xs: 4, md: 0 }, textAlign: { xs: "center", md: "left" }, display: "flex", flexDirection: "column", alignItems: { xs: "center", md: "flex-start" } }}>
            <Typography color="#fff" fontWeight={700} sx={{ mb: 1 }}>
              Home
            </Typography>
            {menus.map((item) => (
              <Typography
                key={item.nome}
                color="#fff"
                sx={{ cursor: "pointer", display: "block", mt: 0.5 }}
                onClick={() => onNavigate(item)}
              >
                {item.nome}
              </Typography>
            ))}
          </Col>

          <Col xs={12} md={4} sx={{ width: { xs: "100%", md: "auto" }, maxWidth: { xs: 400, md: "none" }, display: "flex", justifyContent: { xs: "center", md: "flex-start" } }}>
            <Formik
              initialValues={{}}
              onSubmit={(values, { resetForm }) => {
                onSubmit(values);
                resetForm({});
              }}
              enableReinitialize
            >
              {({ handleChange, handleBlur, values }) => (
                <Form style={{ width: "100%" }}>
                  <Stack spacing={2} alignItems={{ xs: "center", md: "stretch" }} sx={{ width: "100%" }}>
                    <Typography color="#fff" fontWeight={700} sx={{ alignSelf: { xs: "center", md: "flex-start" } }}>
                      Contato
                    </Typography>
                    <Field
                      as={Input}
                      focused={false}
                      id="nome"
                      name="nome"
                      placeholder="Nome"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.nome}
                    />
                    <Field
                      as={Input}
                      focused={false}
                      id="telefone"
                      name="telefone"
                      placeholder="Telefone"
                    />
                    <Field
                      as={Input}
                      focused={false}
                      id="description"
                      name="description"
                      placeholder="Mensagem"
                      rows={4}
                      multiline
                    />
                    <Button fullWidth type="submit">
                      Enviar
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Box>

      {/* Barra inferior: mesma largura e padding, fundo mais escuro, uma linha */}
      <Box
        sx={{
          backgroundColor: "#003466",
          width: "100%",
          py: 1.5,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: 1600,
            margin: "0 auto",
            paddingLeft: "24px",
            paddingRight: "24px",
            boxSizing: "border-box",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "center", md: "center" },
            justifyContent: { xs: "center", md: "space-between" },
            gap: 1,
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography color="#fff" fontSize={13} component="span">
            Todos os direitos reservados - 2022 - Smart
          </Typography>
          <Typography color="#fff" fontSize={13} component="span">
            <Phone sx={{ fontSize: 14, verticalAlign: "middle" }} /> (11) 91187-7987
            {" · "}
            <Email sx={{ fontSize: 14, verticalAlign: "middle" }} /> contato@acheseupintor.com.br
          </Typography>
          <Typography
            color="#fff"
            fontSize={13}
            component="span"
            sx={{ cursor: "pointer" }}
            onClick={() => onNavigate({ url: "/politica-privacidade" })}
          >
            Política de Privacidade Ache seu Pintor
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
